import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { IFinanzaDetallePagoEnLinea } from "../entidad/FinanzaPagoEnLinea";
import { IFinanzaEdoCtaMovimiento, IFinanzaFolioPagoEnLinea } from "../entidad/FinanzasEstadoCuenta";
import { Global } from "../Global";
import { DataUtilLocalStorage } from "../util/LocalStorage";
import { DataUtil } from "../util/Util";

import CTipoPago = Entidad.CTipoPago;

interface IRespuestaRegistroPagos {
    IdMovimiento: number;
    IdPago: number;
}

/** Movimiento */
interface IDataToPay {
    /** Id del cargo */
    Id: number;
    Monto: number;
    TipoPago: CTipoPago;
}

export async function _SvAlumnoEdoCtaObtenerListaMovimientos(idAlumno: number, idEscuela?: number) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/ObtenerListaMovimientosAlumnoV2";
    const params = {
        IdAlumno: idAlumno,
        IdEscuela: idEscuela
    }
    if (!idEscuela) {
        delete params.IdEscuela;
    }
    return DataDRequest._Request5<IFinanzaEdoCtaMovimiento[]>(url, "GET", params);
}

/** @deprecated */
export async function _SvAlumnoEdoCtaNuevoPago(idMovimiento: number, montoPago: number, idMetodoPago, tipoPago: Entidad.CTipoPago): Promise<DataDRequest.IResultadoPeticion<null>> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/NuevoPago";
    const params = {
        "IdMovimiento": idMovimiento,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdMetodoPago": idMetodoPago,
        "TipoPago": tipoPago,
        "Monto": montoPago
    }

    return new Promise(async (resolve, reject) => {
        DataDRequest._Request2<{ Resultado: number }>(url, "POST", params)
            .then((res) => {
                console.log(res)
                resolve({
                    Resultado: (!res.error && res.data?.Resultado) ? res.data.Resultado : -1
                })
            })
    })
}

type NuevoPagoMultipleResponse = DataDRequest.IRequestResponseA<IRespuestaRegistroPagos[]> & IRespuestaRegistroPagosErrorDetail_Code6;
type IRespuestaRegistroPagosErrorDetail_Code6 = {
    DetalleError: { IdPadre: number, UltimaFechaPago: string }[];
}
export async function _SvAlumnoEdoCtaNuevoPagoMultiple(idMetodoPago: number, fechaPagoUTC: string | null, movimientos: IDataToPay[]): Promise<NuevoPagoMultipleResponse> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/NuevoPagoMultiple";
    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdMetodoPago": idMetodoPago,
        "FechaPago": fechaPagoUTC,
        "Movimientos": movimientos
    }
    return DataDRequest._Request5<IRespuestaRegistroPagos[], IRespuestaRegistroPagosErrorDetail_Code6>(url, "POST", params)
}

export async function _SvAlumnoEdoCtaNuevosDescuentos(idsAsignaciones: number[], idAlumno: number, idDescuento: number) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/NuevosDescuentosEstadoCuenta"; //"finanzas/NuevoDescuentoEstadoCuenta";
    const params = {
        // "IdPadre": idPadre,
        "Asignaciones": idsAsignaciones,
        "IdAlumno": idAlumno,
        "IdDescuento": idDescuento,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
    }
    return DataDRequest._Request5(url, "POST", params);
}

export async function _SvAlumnoEdoCtaEliminarMovimiento(idAlumno: number, idMovimiento: number) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/EdoCuentaEliminar";
    const params = {
        "IdMovimiento": idMovimiento,
        "IdAlumno": idAlumno,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
    }
    return DataDRequest._Request5(url, "POST", params);
}

export function _SvAlumnoEdoCtaEliminarDescuento(idMovimientoDetalle: number, idPadre: number) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/EliminarDescuentoEstadoCuenta";
    const params = {
        "IdPadre": idPadre,
        "IdMovimiento": idMovimientoDetalle,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
    }

    return DataDRequest._Request5(url, "POST", params);
}

export function _SvAlumnoEdoCtaEliminarMorosidad(idMovimientoDetalle: number, idPadre: number) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/EliminarMorosidad";
    const params = {
        "IdPadre": idPadre,
        "IdMovimiento": idMovimientoDetalle,
        "IdUsuario": DataUtil._Usuario.IdUsuario
    }
    return DataDRequest._Request5(url, "POST", params);
}

export function _SvAlumnoEdoCtaEliminarPagoCompleto(idMovimientoDetalle: number, idPadre: number) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/EliminarPagoCompleto";
    const params = {
        "IdPadre": idPadre,
        "IdMovimiento": idMovimientoDetalle,
        "IdUsuario": DataUtil._Usuario.IdUsuario
    }
    return DataDRequest._Request5(url, "POST", params);
}

/** `Map`<`FolioPago`, `IFinanzaFolioPagoEnLinea`> */
export const _DICC_ALUMNO_MOVPAGO_FOLIO = new Map<string, IFinanzaFolioPagoEnLinea>();

/**
 * Obtiene los folios de pago en línea (pendientes y exitosos) relacionados al alumno,
 * y los guarda en el diccionario {@link _DICC_ALUMNO_MOVPAGO_FOLIO} para su consulta posterior.
 * @param idAlumno Id del alumno
 * @param idEscuela Id de la escuela
 * @returns Respuesta de la petición, con un arreglo de folios de pago en línea relacionados al alumno
 * @remarks El diccionario {@link _DICC_ALUMNO_MOVPAGO_FOLIO} se limpia y se vuelve a llenar
 * con los datos obtenidos en esta función, por lo que se recomienda llamar a esta función
 * cada vez que se quiera actualizar la información de los folios de pago en línea relacionados al alumno.
 */
export function _SvAlumnoEdoCtaObtenerFoliosPagoEnLinea(idAlumno: number, idEscuela: number) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/ObtenerFoliosPagoEnLinea";
    const params = {
        "IdAlumno": idAlumno,
        "IdEscuela": idEscuela,
    }
    return DataDRequest._Request5<IFinanzaFolioPagoEnLinea[]>(url, "GET", params)
        .then(res => {
            if (res.Resultado > 0) {
                _DICC_ALUMNO_MOVPAGO_FOLIO.clear();
                res.Datos?.forEach(folioPago => {
                    _DICC_ALUMNO_MOVPAGO_FOLIO.set(folioPago.Folio, folioPago);
                });
            }
            return res;
        });
}

let DICC_ALUMNO_MOVPAGO_DETALLE: Map<number, Promise<IFinanzaDetallePagoEnLinea>>;
export function _AlumnoEdoCtaObtenerDetallesPagoEnLinea(idMovimiento: number, onlyFromCache = false): Promise<DataDRequest.IRequestResponseA<IFinanzaDetallePagoEnLinea>> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "finanzas/ObtenerDetallesPagoEnLinea";
    const params = { IdMovimiento: idMovimiento };
    const localStorageGroup = "finanzas-detalles-pago-en-linea";

    // >> Inicializar los datos guardados en `localStorage`
    if (!DICC_ALUMNO_MOVPAGO_DETALLE) {
        DICC_ALUMNO_MOVPAGO_DETALLE = new Map<number, Promise<IFinanzaDetallePagoEnLinea>>();
        const saved: Map<string, string> = DataUtilLocalStorage._GetAllItems(localStorageGroup)
        if (saved) {
            saved.forEach((detalleStr, idMovimientoStr) => {
                const detalle: IFinanzaDetallePagoEnLinea = JSON.parse(detalleStr);
                DICC_ALUMNO_MOVPAGO_DETALLE.set(Number(idMovimientoStr), Promise.resolve(detalle));
            })
        }
    }

    // >> Buscar consulta en curso o guardada en `localStorage`
    if (DICC_ALUMNO_MOVPAGO_DETALLE.has(idMovimiento)) {
        return DICC_ALUMNO_MOVPAGO_DETALLE.get(idMovimiento)
            .then(detalle => ({
                Resultado: 1,
                Datos: detalle
            } as DataDRequest.IRequestResponseA<IFinanzaDetallePagoEnLinea>));
    }
    if (onlyFromCache) {
        return Promise.resolve({
            Resultado: -1,
            Datos: null
        });
    }

    // >> Si no se encontró y no se indicó que solo se busque en caché, hacer la consulta
    const requestPromise = DataDRequest._Request5<IFinanzaDetallePagoEnLinea>(url, "GET", params)
        .then(res => {
            if (res.Resultado > 0 && res.Datos) {
                DataUtilLocalStorage._SetItem(localStorageGroup, idMovimiento.toString(), JSON.stringify(res.Datos));
            } else {
                DICC_ALUMNO_MOVPAGO_DETALLE.delete(idMovimiento);
            }
            return res;
        });

    DICC_ALUMNO_MOVPAGO_DETALLE.set(idMovimiento, requestPromise.then(res => res.Datos));
    return requestPromise;
}